var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #62797e;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        opacity: .7;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        fill: #0eaa82;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        stroke-width: 2px;\n      }\n\n      .cls-4 {\n        opacity: .5;\n      }\n\n      .cls-5 {\n        opacity: .2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.5,
    y: 8.3,
    width: 14,
    height: 44.5,
    rx: 4.6,
    ry: 4.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.6,
    y1: 72.1,
    x2: 37.3,
    y2: 72.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "40 72.1 40 27.6 40 12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "46.9 18.7 40 29.8 33.5 22.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.2,
    y1: 44.7,
    x2: 47.5,
    y2: 36.8
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.5,
    y: 4.9,
    width: 22,
    height: 51,
    rx: 5.4,
    ry: 5.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.7,48.3c0,6.1-3.5,11.1-7.8,11.1s-7.8-4.9-7.8-11.1,5.3-15.2,7.8-15.2,7.8,9.1,7.8,15.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.7,
    y1: 72.1,
    x2: 12.2,
    y2: 72.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "14.5 71.6 14.5 53.4 19.7 47.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.5,
    y1: 59.4,
    x2: 9.3,
    y2: 53.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.8,48.8c0,8.1-4.8,14.7-10.8,14.7s-10.8-6.6-10.8-14.7,7.4-20.1,10.8-20.1,10.8,12,10.8,20.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.5,
    y1: 53.4,
    x2: 14.5,
    y2: 45.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 65.3,
    cy: 48.3,
    rx: 5.7,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 67.4,
    y1: 72.1,
    x2: 63.1,
    y2: 72.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "65.3 72.1 65.3 52.8 65.3 46.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 65.4,
    y1: 51.9,
    x2: 69.2,
    y2: 48.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65.3,
    cy: 48.2,
    r: 9.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees);
export default __webpack_public_path__ + "static/media/trees.431cc6aa3d380eb76cb98cdb81995d7c.svg";
export { ForwardRef as ReactComponent };